import { render, staticRenderFns } from "./createFolderForm.vue?vue&type=template&id=15f871d2&scoped=true&"
import script from "./createFolderForm.vue?vue&type=script&lang=js&"
export * from "./createFolderForm.vue?vue&type=script&lang=js&"
import style0 from "./createFolderForm.vue?vue&type=style&index=0&id=15f871d2&prod&class=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f871d2",
  null
  
)

export default component.exports